import CorporateDataService from "../../../../context/corporates.services";

export const UpdateStatusCompany = async ({ id, value, enqueueSnackbar, setIsLoading }) => {
    try {
        if(value !== '') {
            setIsLoading(true);
            await CorporateDataService.updateCorporate('status', Number(value), id);
            enqueueSnackbar(`Le status a bien été modifié en ${value === '1' ? 'activée' : value === '2' ? 'archivé' : 'pause'}.`, {
                variant: 'success',
                anchorOrigin: { vertical: 'bottom', horizontal: 'center' },
                autoHideDuration: 3000,
                style: {fontSize: '1.6rem'}
               
              });
              return true;
        }else{
            enqueueSnackbar(`Veuillez séléctionner un status`, {
                variant: 'error',
                anchorOrigin: { vertical: 'bottom', horizontal: 'center' },
                autoHideDuration: 3000,
                style: {fontSize: '1.6rem'}  
            });
        }
    }catch(e) {
        enqueueSnackbar(`${e.message}`, {
            variant: 'error',
            anchorOrigin: { vertical: 'bottom', horizontal: 'center' },
            autoHideDuration: 3000,
            style: {fontSize: '1.6rem'}  
        });
        setIsLoading(false);
        return false;
    }
};